import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductDto } from 'src/app/core/dtos/dto';
import { BrandEnum, ProductTypeEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-study-material-modal',
  templateUrl: './study-material-modal.component.html',
  styleUrls: ['./study-material-modal.component.scss']
})
export class StudyMaterialModalComponent implements OnInit {

  @Input() product: ProductDto;
  @Input() brandId: BrandEnum;
  @Output() addItem: EventEmitter<number> = new EventEmitter();

  hasNgCollapse: boolean;
  collapsibleDescription: string;
  nonCollapsibleDescription: string;
  electronicProductId = ProductTypeEnum.ElectronicProductFile;
  isCollapsed = true;

  constructor(
    public activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    //use ng-bootstrap instead of the current bootstrap
    this.addNgbCollapseToDescription(this.product?.description);
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  addNgbCollapseToDescription(description: string) {
    const pattern = /data-toggle="collapse"/;
    if (description?.match(pattern)) {
      this.hasNgCollapse = true;
      const splitArray = description.split('Read more');
      const beforeReadMore = splitArray[0];
      const afterReadMore = splitArray[1];

      //The technical requirement for practice test sets should not be collapsed
      if (this.product.productTypeId === ProductTypeEnum.ElectronicProductOnline) {
        const technicalRequirementsIndex = afterReadMore.indexOf('<h3><strong');
        const technicalRequirements = afterReadMore.slice(technicalRequirementsIndex);
        this.nonCollapsibleDescription = beforeReadMore + technicalRequirements;
        this.collapsibleDescription = afterReadMore.match(/<h3[^"]+?\<\/ul>/)[0];
      }
      else {
        this.nonCollapsibleDescription = beforeReadMore;
        const separatorIndex = afterReadMore.indexOf('<h3>');
        this.collapsibleDescription = afterReadMore.slice(separatorIndex);
      }
    }
  }

  onContinue() {
    this.activeModal.close();
  }

  onAddItemToCart(productId: number) {
    this.addItem.emit(productId);
    this.activeModal.close();
  }

}
